const setBodyOverflow = (newValue: boolean) => {
    if (newValue) {
        document.body.classList.add('overflow-hidden');
    } else {
        document.body.classList.remove('overflow-hidden');
    }
};

export default setBodyOverflow